import { API_URL } from "@cd2/fileboy-react"

export function insertBefore(el: any, referenceNode: any) {
  referenceNode.parentNode.insertBefore(el, referenceNode)
}

export interface IGlobalConfig {
  publicKey: string
  apiUrl: string
}
export function getFileboyGlobalConfig(): IGlobalConfig {
  const w: any = window
  return {
    publicKey: w.FILEBOY_PUBLIC_KEY,
    apiUrl: w.FILEBOY_API_URL || API_URL || "https://www.developingexperts.com/file-cdn",
  }
}
